
export const EMAIL_REPORT ="Email Report"
export const EMAIL_REPORT_TITLE ="emailReport"
export const EMAIL_INFO_MESSAGE ="Displays the Email report for the date range provided"

// TODO: types
export const columns: any[] = [
  { name: 'repairerName', title: 'Repairer Name' },
  { name: 'repairerGroup', title: 'Repairer Group' },
  { name: 'schemeCode', title: 'Scheme Code' },
  { name: 'workProvider', title: 'Work Provider' },
  { name: 'regmark', title: 'Vehicle Reg.' },
  { name: 'emailSentDate', title: 'Email Date and Time', type: 'date' },
  { name: 'subject', title: 'Email Subject', width: '200' },
];

export const summaryItems = [{ columnName: 'repairerName', type: 'count', customizeText: ({value}: {value: string | number | Date})  => `Total Messages: ${value}`}];

// TODO: remove after testing
export const mockedEmailReports = [
  {
    repairerName: "John Smith",
    repairerGroup: "Group A",
    schemeCode: "SC001",
    workProvider: "Provider 1",
    siteCode: "SITE01",
    emailSentDate: "2024-04-20",
    subject: "Repair Confirmation",
    regmark: "ABC1234"
  },
  {
    repairerName: "Anna Brown",
    repairerGroup: "Group B",
    schemeCode: "SC002",
    workProvider: "Provider 2",
    siteCode: "SITE02",
    emailSentDate: "2024-04-21",
    subject: "Parts Order",
    regmark: "XYZ5678"
  },
  {
    repairerName: "Peter Wilson",
    repairerGroup: "Group A",
    schemeCode: "SC003",
    workProvider: "Provider 3",
    siteCode: "SITE03",
    emailSentDate: "2024-04-22",
    subject: "Repair Completion",
    regmark: "DEF4321"
  },
  {
    repairerName: "Catherine Green",
    repairerGroup: "Group C",
    schemeCode: "SC004",
    workProvider: "Provider 1",
    siteCode: "SITE04",
    emailSentDate: "2024-04-23",
    subject: "Collection Reminder",
    regmark: "GHI8765"
  },
  {
    repairerName: "Mark Lewis",
    repairerGroup: "Group B",
    schemeCode: "SC005",
    workProvider: "Provider 2",
    siteCode: "SITE05",
    emailSentDate: "2024-04-24",
    subject: "Repair On Hold",
    regmark: "JKL0987"
  }
];
